<app-si-dialog [hideHeader]="true" [isLoading]="isLoading$ | async" modalFooterClasses="si-dialog__footer--centered">
	<ng-template appDialogBody>
		<div class="px-16 py-8">
			<div class="flex items-start gap-5">
				<fa-icon class="text-danger shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
				<div>
					<p class="m-0">Do you want to save this search, before clearing the search criteria?</p>
					<div class="mt-4" *ngIf="activeSearch">
						<div *ngIf="canUpdateSearch; else notSameUser">You can update <strong class="font-700 break-words">'{{ activeSearch.searchName }}'</strong><div>Or</div></div>
						<ng-template #notSameUser>
							<div>You cannot update <strong class="font-700 break-words">'{{ activeSearch.searchName }}'</strong> as
								{{ activeSearch.lock ? 'this Saved Search is locked' : 'you are not the owner' }}.</div>
						</ng-template>
						{{ activeSearch.lock ? 'Click Create New below to save as a new search.' : 'Save as a new search' }}
					</div>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template appDialogFooter>
		<button matButton="outlined" type="button" (click)="onClose()">Cancel</button>
		<button matButton="filled" type="button" class="mat-error" (click)="onDoNotSave()">Do Not Save</button>
		<ng-container *ngIf="hasExistingSavedSearch; else saveAction">
			<ng-container *ngIf="canUpdateSearch; else createNewAction">
				<button
					matButton="filled"
					type="button"
					class="si-menu-trigger"
					[matMenuTriggerFor]="saveActionsMenu"
					[disabled]="isLoading$ | async"
				>
					<span>Save</span>
					<span class="si-menu-trigger-icon" aria-hidden="true"></span>
				</button>
			</ng-container>
		</ng-container>
		<ng-template #createNewAction>
			<button matButton="filled" type="button" [disabled]="isLoading$ | async" (click)="onOpenSaveDialog()">Create New</button>
		</ng-template>
		<ng-template #saveAction>
			<button matButton="filled" type="button" [disabled]="isLoading$ | async" (click)="onOpenSaveDialog()">Save</button>
		</ng-template>
	</ng-template>
</app-si-dialog>

<mat-menu #saveActionsMenu="matMenu" xPosition="before">
	<button mat-menu-item type="button" (click)="onUpdateSearch()" [disabled]="isLoading$ | async">
		Update
	</button>
	<button mat-menu-item type="button" (click)="onOpenSaveDialog()" [disabled]="isLoading$ | async">
		Create New
	</button>
</mat-menu>
